import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';

import { Location } from './location.model';
import { AbstractEntityService } from '../../shared/service/abstract-entity.service';

@Injectable()
export class LocationService extends AbstractEntityService {

    protected resourceUrl = 'api/locations';
    private resourceSearchUrl = 'api/_search/locations';
    protected resourceCountUrl = 'api/_search/count/locations';

    constructor(protected http: HttpClient) { super(http); }

    create(location: Location): Observable<Location> {
        let copy: Location = Object.assign({}, location);
        return this.http.post<Location>(this.resourceUrl, copy).map((res: Location) => {
            return res;
        });
    }

    update(location: Location): Observable<Location> {
        let copy: Location = Object.assign({}, location);
        return this.http.put<Location>(this.resourceUrl, copy).map((res: Location) => {
            return res;
        });
    }

    find(id: number): Observable<Location> {
        return this.http.get<Location>(`${this.resourceUrl}/${id}`).map((res: Location) => {
            return res;
        });
    }

    query(req?: any): Observable<HttpResponse<Location[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<Location[]>>(this.resourceUrl, options)
            ;
    }

    search(req?: any): Observable<HttpResponse<Location[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<Location[]>>(this.resourceSearchUrl, options)
            ;
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/location/location.service.ts